export default {

	systemName: 'COIN ANT',

	token: '',

  // menu list data
  mainMenu: [
	  {
			id: 1,
		  icon_img: '/static/images/common/menu_icons/icon_home.png',
		  name: ['首页', 'HOME'],
		  routerName: 'home',
		  type: 'link',
		  children: []
	  },
	  {
			id: 2,
		  icon_img: '/static/images/common/menu_icons/icon_company.png',
		  name: ['公司简介', 'COMPANY'],
		  routerName: 'company',
		  type: 'button',
		  children: [
			  {
					id: 201,
				  name: '股东介绍',
				  routerName: 'introduction',
				  type: 'link',
				  children: []
			  },
			  {
				  id: 202,
				  name: '公司简介',
				  routerName: 'company',
				  type: 'link',
				  children: []
			  },
			  {
				  id: 203,
				  name: '公司领导',
				  routerName: 'leaders',
				  type: 'link',
				  children: []
			  }
		  ]
	  },
	  { id: 3,
		  icon_img: '/static/images/common/menu_icons/icon_business.png',
		  name: ['业务领域', 'BUSINESS'],
		  routerName: 'business',
		  children: [
			  {
				  id: 301,
				  name: '细分市场',
				  routerName: '',
				  type: 'button',
				  children: [
						{
						  id: 30101,
						  name: '细分市场',
						  routerName: 'market-segments',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30102,
						  name: '航空航天',
						  routerName: 'aerospace',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30103,
						  name: '专业责任',
						  routerName: 'responsibility',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30104,
						  name: '交通运输',
						  routerName: 'transportation',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30105,
						  name: '影视娱乐',
						  routerName: 'entertainment',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30106,
						  name: '工业制造',
						  routerName: 'industrial-manufacturing',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30107,
						  name: '工业保险',
						  routerName: 'agricultural-insurance',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30108,
						  name: '一带一路',
						  routerName: 'the-belt-and-road-initiative',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30109,
						  name: '教育安全',
						  routerName: 'educational-security',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30110,
						  name: '应急管理',
						  routerName: 'contingency-management',
						  type: 'link',
						  children: []
					  },
					  {
						  id: 30111,
						  name: '体育赛事',
						  routerName: 'sports-events',
						  type: 'link',
						  children: []
					  },
				  ]
			  },
			  {
				  id: 302,
				  name: '再保险业务',
				  routerName: 'reinsurance-business',
				  type: 'link',
				  children: []
			  },
			  {
				  id: 303,
				  name: '互联网保险',
				  routerName: 'internet-insurance',
				  type: 'link',
				  children: []
			  }
		  ]
	  },
	  {
			id: 4,
		  icon_img: '/static/images/common/menu_icons/icon_service_objectives.png',
		  name: ['服务目标和内容', 'SERVICE OBJECTIVES'],
		  routerName: 'service-objectives',
		  type: 'button',
		  children: [
			  {
				  id: 402,
				  name: '服务目标',
				  routerName: 'service-objectives',
				  type: 'link'
			  },
			  {
				  id: 403,
				  name: '服务内容',
				  routerName: 'service-contents',
				  type: 'link'
			  }
		  ]
	  },
	  {
			id: 5,
		  icon_img: '/static/images/common/menu_icons/icon_service_network.png',
		  name: ['服务网络', 'SERVICE NETWORK'],
		  routerName: 'service-network',
		  type: 'link',
		  children: []
	  },
	  {
			id: 6,
		  icon_img: '/static/images/common/menu_icons/icon_information.png',
		  name: ['信息披露', 'INFORMATION'],
		  routerName: 'information',
		  type: 'link',
		  children: []
	  },
	  /*{
			id: 7,
		  icon_img: '/static/images/common/menu_icons/icon_hot_product.png',
		  name: ['热销产品', 'HOT PRODUCT'],
		  routerName: 'hot-product',
		  type: 'link',
		  children: []
	  },*/
	  /*{
			id: 8,
		  icon_img: '/static/images/common/menu_icons/icon_announcement.png',
		  name: ['公告发布', 'ANNOUNCEMENT'],
		  routerName: 'announcement',
		  type: 'link',
		  children: []
	  },*/
	
	  {
		  id: 9,
		  icon_img: '/static/images/common/menu_icons/icon_announcement.png',
		  name: ['通知公告', 'COMPANY DYNAMIC'],
		  routerName: 'notice-announcement',
		  type: 'link',
		  children: []
	  },
	
	  /*{
		  id: 10,
		  icon_img: '/static/images/common/menu_icons/icon_contact_us.png',
		  name: ['联系我们', 'CONTACT US'],
		  routerName: 'contact-us',
		  type: 'link',
		  children: []
	  }*/
  ],

  // 超时提示
  loginTimeout: {
    isAlert: false // 是否已提示 (false：尚未提示，true：已提示)
  },

  // 提示框类型
  isPublicAlarm: true, // 提示框类型 (true：公共提示框，false：自定义提示框)
	
	notificationPos: 'top-right', // 系统消息提示框位置,

  // 开发、验收环境
  baseUrl: {
    url_01: '',
  },

}
